import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA service worker — same-origin script, network passthrough only
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

// Capture the Chrome/Android install prompt as early as possible so the
// login page "Install app" button can trigger a real one-tap install.
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault(); // suppress the mini-infobar; we show our own UI
  window.__rkInstallPrompt = e;
  window.dispatchEvent(new CustomEvent("rk-install-ready"));
});
window.addEventListener("appinstalled", () => {
  window.__rkInstallPrompt = null;
  window.dispatchEvent(new CustomEvent("rk-installed"));
});
